<template>
  <v-dialog v-model="internalDialog" max-width="54rem" persistent scrollable>
    <v-card class="pa-6">
      <v-card-title class="text-h5 font-weight-bold pb-2">
        {{ title }}
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="form">
          <v-row dense class="pt-4">
            <template v-for="field in fields" :key="field.model">
              <span class="label">{{ field.label }}</span>
              <span class="required-star"></span>
              <!-- Text Fields -->
              <v-col cols="12" v-if="field.type === 'text'">
                <v-text-field
                  v-model="formData[field.model]"
                  :rules="[
                    field.required ? (v) => !!v || 'Required' : () => true,
                  ]"
                  variant="outlined"
                  density="comfortable"
                  class="custom-field custom-label"
                />
              </v-col>

              <!-- File Fields -->
              <v-col cols="12" v-if="field.type === 'file'">
                <v-file-input
                  v-model="formData[field.model]"
                  :rules="[
                    field.required ? (v) => !!v || 'Required' : () => true,
                  ]"
                  variant="outlined"
                  density="comfortable"
                  class="custom-field custom-label"
                />
              </v-col>

              <!-- Select Fields -->
              <v-col cols="12" v-if="field.type === 'select'">
                <v-autocomplete
                  v-model="formData[field.model]"
                  :items="fieldItems[field.model] || []"
                  :item-value="field.itemValue || 'id'"
                  :item-title="field.itemTitle || 'name'"
                  :rules="[
                    field.required
                      ? (v) =>
                          field.type === 'switch'
                            ? v === true || v === false
                            : !!v || 'Required'
                      : () => true,
                  ]"
                  :multiple="field.multiple || false"
                  :loading="loadingFields[field.model]"
                  chips
                  variant="outlined"
                  density="comfortable"
                  class="custom-field custom-label"
                />
              </v-col>
              <!-- Switch Field -->
              <v-col cols="12" v-if="field.type === 'switch'">
                <div class="d-flex justify-space-between align-center">
                  <v-switch
                    v-model="formData[field.model]"
                    inset
                    color="primary"
                    hide-details
                  ></v-switch>
                </div>
              </v-col>
              <!-- Date Field -->
              <v-col cols="12" v-if="field.type === 'date'">
                <Flatpickr
                  style="
                    width: 100%;
                    border: 1px solid rgb(171, 171, 171);
                    font-size: 14px;
                    color: #666666;
                    padding: 9px 5px;
                    border-radius: 4px;
                  "
                  :config="config"
                  v-model="formData[field.model]"
                  type="date"
                  variant="outlined"
                  density="comfortable"
                  class="custom-field custom-label"
                />
              </v-col>
              <!-- Datetime Field -->
              <v-col cols="12" v-if="field.type === 'datetime'">
                <Flatpickr
                  style="
                    width: 100%;
                    border: 1px solid rgb(171, 171, 171);
                    font-size: 14px;
                    color: #666666;
                    padding: 9px 5px;
                    border-radius: 4px;
                  "
                  :config="config"
                  v-model="formData[field.model]"
                  type="datetime-local"
                  variant="outlined"
                  density="comfortable"
                  class="custom-field custom-label"
                />
              </v-col>
            </template>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-end pt-4">
        <v-spacer></v-spacer>
        <v-btn class="cancel-btn cursor-pointer" @click="closeDialog"
          >Cancel</v-btn
        >
        <v-btn class="choose-btn cursor-pointer" @click="submitForm"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import apiClient from "@/core/buildRequest";
// import { VDateInput } from 'vuetify/labs/VDateInput'
import Flatpickr from "vue-flatpickr-component";
import { VFileUpload } from "vuetify/labs/VFileUpload";

import "flatpickr/dist/flatpickr.css";

export default {
  name: "GeneralEdit",
  props: {
    dialog: Boolean,
    title: String,
    recordId: [String, Number],
    apiEndpoint: String,
    fields: Array,
    masterData: Object,
  },
  emits: ["update:dialog", "submitted"],
  components: {
    Flatpickr,
    VFileUpload,
  },
  data() {
    return {
      config: {
        enableTime: true,
        dateFormat: "Y-m-d H:i:s",
      },
      formData: {},
      fieldItems: {},
      loadingFields: {},
      internalDialog: false,
      attachment: null,
    };
  },
  watch: {
    dialog(val) {
      this.internalDialog = val;
      if (val) this.loadData();
    },
    internalDialog(val) {
      this.$emit("update:dialog", val);
    },
    "formData.country_id"(newVal) {
      this.formData.city_id = null;
      this.loadCityOptions(newVal);
    },
  },
  methods: {
    closeDialog() {
      this.internalDialog = false;
    },

    async loadData() {
      const res = await apiClient.get(`${this.apiEndpoint}/${this.recordId}`);
      const data = res.data?.data;
      console.log(data);
      this.fields.forEach((field) => {
        if (field.lazy) return;
        if (field.map) {
          this.formData[field.model] = field.map(data);
        } else if (field.type === "switch") {
          this.formData[field.model] = Boolean(Number(data[field.model] ?? 0));
        } else {
          this.formData[field.model] = data[field.model] ?? null;
        }
        if (field.items) {
          this.fieldItems[field.model] = field.items;
        }
      });

      await this.prefetchLazyFields();
      await this.loadCityOptions(this.formData.country_id);

      this.fields.forEach((field) => {
        if (!field.lazy) return;

        if (field.map) {
          this.formData[field.model] = field.map(data);
        } else {
          this.formData[field.model] = data[field.model] ?? null;
        }
      });
      console.log("Raw add_to_calendar from API:", data.add_to_calendar);
    },

    async prefetchLazyFields() {
      const promises = this.fields
        .filter((field) => field.lazy && !field.dependsOn)
        .map(async (field) => {
          const endpoint =
            typeof field.getRemoteEndpoint === "function"
              ? field.getRemoteEndpoint(this.formData)
              : field.remoteEndpoint;

          if (!endpoint) {
            this.fieldItems[field.model] = [];
            return;
          }

          const res = await apiClient.get(endpoint);
          this.fieldItems[field.model] = res.data?.data || [];
        });

      await Promise.all(promises);
    },

    async loadCityOptions(countryId) {
      if (!countryId) {
        this.fieldItems["city_id"] = [];
        return;
      }

      try {
        this.loadingFields["city_id"] = true;
        const res = await apiClient.get(`/leads-managment/cities/${countryId}`);
        this.fieldItems["city_id"] = res.data?.data || [];

        const cityField = this.fields.find((f) => f.model === "city_id");
        const resData = (
          await apiClient.get(`${this.apiEndpoint}/${this.recordId}`)
        ).data?.data;

        if (cityField?.map) {
          this.formData.city_id = cityField.map(resData);
        } else {
          this.formData.city_id = resData.city_id ?? null;
        }
      } catch (e) {
        console.error(e);
        this.fieldItems["city_id"] = [];
      } finally {
        this.loadingFields["city_id"] = false;
      }
    },

    async submitForm() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      const normalizedData = { ...this.formData };

      const booleanFields = this.fields
        .filter((field) => field.type === "switch")
        .map((field) => field.model);

      const apiFieldMap = {
        contacts_ids: "contact_id",
        members_ids: "member_id",
        assignee_ids: "assignee_id",
      };

      const formData = new FormData();

      Object.keys(normalizedData).forEach((key) => {
        const apiKey = apiFieldMap[key] || key;
        let value = normalizedData[key];

        if (booleanFields.includes(key)) {
          value = value ? 1 : 0;
          formData.append(apiKey, value);
          return;
        }

        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            formData.append(`${apiKey}[${index}]`, item);
          });
          return;
        }

        formData.append(apiKey, value);
      });

      await apiClient.post(`${this.apiEndpoint}/${this.recordId}`, formData);
      this.$emit("submitted");
      this.closeDialog();
    },
  },
};
</script>

<style scoped>
.v-dialog > .v-overlay__content > .v-card {
  margin: 2rem;
}

.custom-label .v-label {
  font-weight: 500;
  font-size: 16px;
}

.required-star::after {
  content: " *";
  color: red;
}

.choose-btn {
  color: #fff;
}

.label {
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  color: #6a6a6a;
}
</style>
